import React, { useState } from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import "./FeatureManagement.css";

const FeatureManagement = () => {
  const [limits, setLimits] = useState({
    maxCandidates: 100,
    maxExams: 20,
    maxProctors: 10,
    storageLimit: 5,
  });

  const [modules, setModules] = useState({
    faceDetection: true,
    screenRecording: true,
    liveProctoring: false,
    autoFlagging: true,
    idVerification: false,
    reportGeneration: true,
  });

  const handleLimitChange = (e: any) => {
    setLimits({
      ...limits,
      [e.target.name]: e.target.value,
    });
  };

  const handleToggle = (key: string) => {
    setModules({
      ...modules,
      [key]: !modules[key as keyof typeof modules],
    });
  };

  return (
    <div className="feature-page">
      <Card className="shadow-sm border-0 feature-card">
        <Card.Body>

          <div className="mb-4">
            <h4 className="fw-bold">Feature Management</h4>
            <small className="text-muted">
              Control limits and module access per company
            </small>
          </div>

          {/* Company Selector */}
          <Form.Select className="mb-4 company-select">
            <option>Select Company</option>
            <option>Demo Company</option>
            <option>HP</option>
            <option>Infosys</option>
          </Form.Select>

          {/* Limit Controls */}
          <Card className="mb-4 section-card">
            <Card.Body>
              <h6 className="section-title">Limit Controls</h6>

              <Row className="mt-3">
                {Object.keys(limits).map((key) => (
                  <Col md={3} key={key}>
                    <Form.Group>
                      <Form.Label className="label">
                        {key.replace(/([A-Z])/g, " $1")}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name={key}
                        value={limits[key as keyof typeof limits]}
                        onChange={handleLimitChange}
                        className="limit-input"
                      />
                    </Form.Group>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>

          {/* Module Access */}
          <Card className="section-card">
            <Card.Body>
              <h6 className="section-title">Module Access</h6>

              <Row className="mt-3">
                {Object.keys(modules).map((key) => (
                  <Col md={4} key={key}>
                    <div className="module-toggle">
                      <span>
                        {key.replace(/([A-Z])/g, " $1")}
                      </span>
                      <Form.Check
                        type="switch"
                        checked={modules[key as keyof typeof modules]}
                        onChange={() => handleToggle(key)}
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>

          <div className="text-end mt-4">
            <Button className="save-btn">
              Save Changes
            </Button>
          </div>

        </Card.Body>
      </Card>
    </div>
  );
};

export default FeatureManagement;